module.exports = __webpack_public_path__ + "img/ppt.25751822.svg";